/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-11 17:15:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-12 14:55:18
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_performance_report\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        mainId: this.paramsProps.mainId,
      },
    };
  },
  methods: {
    setColumn(col) {
      const item = col;
      if (item.field === 'checkTypeseq') {
        item.title = '序号';
        item.width = '50';
      }
      return item;
    },
  },
  created() {
    this.getConfigList('detail-list');
  },
};
